import React, { useEffect } from "react";
import * as yup from "yup";
import Swal from "sweetalert2";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import { useLoginUserMutation } from "../../../utils/api/user.api";
import { useDispatch } from "react-redux";
import { onSetUserToken } from "../../../utils/api/slice/user.slice";
import { cleannerError } from "../../../utils/utils";
import { AppLocalStorage } from "../../../utils/storage";

function UseLoginForm() {
  const validationSchema = yup.object().shape({
    username: yup
      .string()
      .required()
      .nullable()
      .label("L'email ou N° de téléphonz"),
    password: yup.string().required().nullable().label("Le code secret"),
  });
  const {
    register,
    handleSubmit,
    formState: { errors },
    clearErrors,
    setError,
    reset,
  } = useForm({
    resolver: yupResolver(validationSchema),
  });
  const dispatch = useDispatch();
  const [loginUser, { isLoading, isSuccess, error, isError, data }] =
    useLoginUserMutation();

  useEffect(() => {
    if (isSuccess) {
      if (data?.token) {
        console.log(data);
        window.localStorage.setItem("userID", data?.user?.id);
        window.localStorage.setItem("userType", data?.user?.user_type);
        window.localStorage.setItem("userToken", data?.token);
        dispatch(onSetUserToken({ user: data?.user, token: data?.token }));
      }
    }
    const err = error;

    if (isError) {
      console.log("error", err);
      setError("username", {
        message: err?.data?.message
          ? err?.data?.message
          : err?.status < 500
          ? "Identifiant ou code secret incorrect"
          : `Une erreur de statut ${err?.status} est survenue.`,
      });

      setTimeout(() => {
        cleannerError(errors, clearErrors);
      }, 3000);
    }
  }, [error, isError, isSuccess]);
  useEffect(() => {
    cleannerError(errors, clearErrors);
  }, [errors]);

  const onSubmit = async (data) => {
    // console.log("data login", data);
    await loginUser(data);
  };

  return {
    register,
    errors: errors,
    onSubmit: handleSubmit(onSubmit),
    isLoading,
  };
}

export default UseLoginForm;
